type InternalAuthFlowRecord = {
  state: string;
  createdAt: number;
};

export type InternalAuthFlowValidationResult = {
  isValid: boolean;
  reason: string;
};

export class InternalAuthFlowUtil {
  private static readonly KEY_INTERNAL_AUTH_FLOW = 'vw_internal_auth_flow';

  static createState(): string {
    const state = this.generateNonce();
    const record: InternalAuthFlowRecord = {
      state,
      createdAt: Date.now()
    };

    sessionStorage.setItem(this.KEY_INTERNAL_AUTH_FLOW, JSON.stringify(record));
    return state;
  }

  static consumeState(candidateState: string | null, ttlMs: number): InternalAuthFlowValidationResult {
    const storedValue = sessionStorage.getItem(this.KEY_INTERNAL_AUTH_FLOW);
    sessionStorage.removeItem(this.KEY_INTERNAL_AUTH_FLOW);

    if (!candidateState || candidateState.trim().length === 0) {
      return { isValid: false, reason: 'state ausente' };
    }

    if (!storedValue) {
      return { isValid: false, reason: 'state nao encontrado ou ja utilizado' };
    }

    try {
      const record = JSON.parse(storedValue) as Partial<InternalAuthFlowRecord>;
      if (!record.state || typeof record.createdAt !== 'number') {
        return { isValid: false, reason: 'state armazenado invalido' };
      }

      if (record.state !== candidateState) {
        return { isValid: false, reason: 'state divergente' };
      }

      if ((Date.now() - record.createdAt) > ttlMs) {
        return { isValid: false, reason: 'state expirado' };
      }

      return { isValid: true, reason: 'state valido' };
    } catch {
      return { isValid: false, reason: 'state armazenado corrompido' };
    }
  }

  static clearState(): void {
    sessionStorage.removeItem(this.KEY_INTERNAL_AUTH_FLOW);
  }

  private static generateNonce(): string {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  }
}